// extracted by mini-css-extract-plugin
module.exports = {"content":"RemoveSubscriptionModal_content__1gbaq","modal":"RemoveSubscriptionModal_modal__2H1Nj"};